/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Video_FullscreenInputs */

const th_video_fullscreen = /** @type {(inputs: Video_FullscreenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`เต็มหน้าจอ`)
};

const en_video_fullscreen = /** @type {(inputs: Video_FullscreenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fullscreen`)
};

const ja_video_fullscreen = /** @type {(inputs: Video_FullscreenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`全画面`)
};

const zh_video_fullscreen = /** @type {(inputs: Video_FullscreenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`全屏`)
};

const es_video_fullscreen = /** @type {(inputs: Video_FullscreenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pantalla completa`)
};

const pt_video_fullscreen = /** @type {(inputs: Video_FullscreenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tela cheia`)
};

const id_video_fullscreen = /** @type {(inputs: Video_FullscreenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Layar penuh`)
};

const fr_video_fullscreen = /** @type {(inputs: Video_FullscreenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plein écran`)
};

const tl_video_fullscreen = /** @type {(inputs: Video_FullscreenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Buong screen`)
};

const vi_video_fullscreen = /** @type {(inputs: Video_FullscreenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Toàn màn hình`)
};

const ko_video_fullscreen = /** @type {(inputs: Video_FullscreenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`전체 화면`)
};

const de_video_fullscreen = /** @type {(inputs: Video_FullscreenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vollbild`)
};

const ru_video_fullscreen = /** @type {(inputs: Video_FullscreenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Во весь экран`)
};

const tr_video_fullscreen = /** @type {(inputs: Video_FullscreenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tam ekran`)
};

const it_video_fullscreen = /** @type {(inputs: Video_FullscreenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Schermo intero`)
};

const pl_video_fullscreen = /** @type {(inputs: Video_FullscreenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pełny ekran`)
};

const uk_video_fullscreen = /** @type {(inputs: Video_FullscreenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`На весь екран`)
};

const hi_video_fullscreen = /** @type {(inputs: Video_FullscreenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`पूर्ण स्क्रीन`)
};

const ar_video_fullscreen = /** @type {(inputs: Video_FullscreenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ملء الشاشة`)
};

const ms_video_fullscreen = /** @type {(inputs: Video_FullscreenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Skrin penuh`)
};

const bn_video_fullscreen = /** @type {(inputs: Video_FullscreenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`পূর্ণ পর্দা`)
};

const zh_tw2_video_fullscreen = /** @type {(inputs: Video_FullscreenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`全螢幕`)
};

const zh_hk2_video_fullscreen = /** @type {(inputs: Video_FullscreenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`全熒幕`)
};

const ur_video_fullscreen = /** @type {(inputs: Video_FullscreenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`پوری اسکرین`)
};

const fa_video_fullscreen = /** @type {(inputs: Video_FullscreenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تمام‌صفحه`)
};

const sw_video_fullscreen = /** @type {(inputs: Video_FullscreenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Skrini nzima`)
};

const nl_video_fullscreen = /** @type {(inputs: Video_FullscreenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Volledig scherm`)
};

/**
* | output |
* | --- |
* | "Fullscreen" |
*
* @param {Video_FullscreenInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const video_fullscreen = /** @type {((inputs?: Video_FullscreenInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Video_FullscreenInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_video_fullscreen(inputs)
	if (locale === "ja") return ja_video_fullscreen(inputs)
	if (locale === "zh") return zh_video_fullscreen(inputs)
	if (locale === "es") return es_video_fullscreen(inputs)
	if (locale === "pt") return pt_video_fullscreen(inputs)
	if (locale === "id") return id_video_fullscreen(inputs)
	if (locale === "fr") return fr_video_fullscreen(inputs)
	if (locale === "tl") return tl_video_fullscreen(inputs)
	if (locale === "vi") return vi_video_fullscreen(inputs)
	if (locale === "ko") return ko_video_fullscreen(inputs)
	if (locale === "de") return de_video_fullscreen(inputs)
	if (locale === "ru") return ru_video_fullscreen(inputs)
	if (locale === "tr") return tr_video_fullscreen(inputs)
	if (locale === "it") return it_video_fullscreen(inputs)
	if (locale === "pl") return pl_video_fullscreen(inputs)
	if (locale === "uk") return uk_video_fullscreen(inputs)
	if (locale === "hi") return hi_video_fullscreen(inputs)
	if (locale === "ar") return ar_video_fullscreen(inputs)
	if (locale === "ms") return ms_video_fullscreen(inputs)
	if (locale === "bn") return bn_video_fullscreen(inputs)
	if (locale === "zh-TW") return zh_tw2_video_fullscreen(inputs)
	if (locale === "zh-HK") return zh_hk2_video_fullscreen(inputs)
	if (locale === "ur") return ur_video_fullscreen(inputs)
	if (locale === "fa") return fa_video_fullscreen(inputs)
	if (locale === "sw") return sw_video_fullscreen(inputs)
	if (locale === "nl") return nl_video_fullscreen(inputs)
	return en_video_fullscreen(inputs)
});